import { useContext, useEffect, useState } from 'react';
import { MyContext } from '../../context';
import DataTable from '../../components/tables/DataTable';
import StatCard from '../../components/StatCard';
import ExportButton from '../../components/ExportButton';
import { getFulfillmentsReport } from '../../utils/queries';

export default function FulfillmentsReport() {
	const { activeStoreId } = useContext(MyContext);
	const [report, setReport] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		setLoading(true);
		getFulfillmentsReport({ storeId: activeStoreId || undefined }).then((result) => {
			if (result?.success) setReport(result.data);
			setLoading(false);
		});
	}, [activeStoreId]);

	const columns = [
		{ key: 'status', header: 'Status' },
		{ key: 'count', header: 'Fulfillments' },
	];

	return (
		<div className='py-8 pr-8'>
			<div className='flex items-center justify-between mb-6'>
				<h1 className='text-2xl font-light tracking-tight'>Fulfillments Report</h1>
				<ExportButton
					fileName='fulfillments-report'
					sections={[
						{
							data: report?.rows || [],
							columns: columns.map((c) => c.header),
							columnKeys: columns.map((c) => c.key),
							columnTypes: ['text', 'number'],
						},
					]}
				/>
			</div>

			{loading || !report ? (
				<div className='text-sm text-gray-400'>Loading...</div>
			) : (
				<>
					<div className='grid grid-cols-4 gap-4 mb-8'>
						<StatCard label='Total Fulfillments' value={report.summary.total_fulfillments} />
						<StatCard label='Shipped' value={report.summary.shipped_count} />
						<StatCard label='Pending' value={report.summary.pending_count} />
						<StatCard label='Avg Turnaround (hrs)' value={report.summary.avg_turnaround_hours ?? '-'} />
					</div>

					<DataTable columns={columns} data={report.rows} emptyHeading='No fulfillments found' />
				</>
			)}
		</div>
	);
}
